export const AppPathNames = (lang) => {
  return {
    "/app/home": null,
    "/app/agencies/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Agency", lang),
    ],
    "/app/agencies/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Agencies List", lang),
    ],
    "/app/agency-lists/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Agency List", lang),
    ],
    "/app/agency-lists/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Agency Lists", lang),
    ],
    "/app/insurance-companies/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Companies List", lang),
    ],
    "/app/insurance-companies/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Company", lang),
    ],
    "/app/insurance-companies/modify": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Modify Company", lang),
    ],
    "/app/insurance-companies/set-prices": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Insurance Prices", lang),
    ],
    "/app/insurance-requests/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Insurances List", lang),
    ],
    "/app/insurance-requests/view-received": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Received Insurances", lang),
    ],
    "/app/insurance-requests/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("New Insurance Request", lang),
    ],
    "/app/roles/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add User Role", lang),
    ],
    "/app/roles/modify": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Update User Role", lang),
    ],
    "/app/roles/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Roles List", lang),
    ],
    "/app/users/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add User", lang),
    ],
    "/app/users/modify": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Update User", lang),
    ],
    "/app/users/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Users List", lang),
    ],
    "/app/expenses/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Expense", lang),
    ],
    "/app/expenses/modify": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Update Expense", lang),
    ],
    "/app/expenses/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Expenses List", lang),
    ],
    "/app/leads/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Lead", lang),
    ],
    "/app/leads/modify": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Update Lead", lang),
    ],
    "/app/leads/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Leads List", lang),
    ],
    "/app/agencies/modify": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Update Agency", lang),
    ],
    "/app/balance-requests/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Balance Requests List", lang),
    ],
    "/app/profits/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Profits", lang),
    ],
    "/app/financial-requests/view-exported": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Financial Activity Report", lang),
    ],
    "/app/reports/agency-activity": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Agency Activity", lang),
    ],
    "/app/reports/incoming-money": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Incoming Money", lang),
    ],
    "/app/reports/insurance-companies": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Insurance Companies", lang),
    ],
    "/app/reports/advanced-reports": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Advanced Reports", lang),
    ],
    "/app/reports/agency-ratios": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Agency Ratios", lang),
    ],
    "/app/translations": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Translations", lang),
    ],
    "/app/announcements/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Announcements", lang),
    ],
    "/app/announcements/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Announcement", lang),
    ],
    "/app/options": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Options", lang),
    ],
    "/app/messaging": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Messaging", lang),
    ],
    "/app/debt-requests/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Debt Request", lang),
    ],
    "/app/debt-requests/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Debt Requests", lang),
    ],
    "/app/message-requests/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Message Requests", lang),
    ],
    "/app/bulk-ratios-requests/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Create Bulk Ratios Request", lang),
    ],
    "/app/bulk-ratios-requests/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Bulk Ratios Requests", lang),
    ],
    "/app/debtsending-schedules/create": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Create DebtSending Schedule", lang),
    ],
    "/app/debtsending-schedules/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("DebtSending Schedules", lang),
    ],
    "/app/money-accounts/view-transactions": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Money Transactions", lang),
    ],
    "/app/money-accounts/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Money Accounts", lang),
    ],
    "/app/invoices/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Invoices", lang),
    ],
    "/app/invoices/create-supplier-bill": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("Add Supplier Bill", lang),
    ],
    "/app/sms-messages/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("SMS Messages", lang),
    ],
    "/app/whatsapp-devices/view-all": [
      window.sys_app_translate("Home", lang),
      ">",
      window.sys_app_translate("WhatsApp Devices", lang),
    ],
  };
};
